import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

//interface for CheckoutSession
interface CheckoutSessionResponse {
  id: string;
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class StripeService {
  makePayment(
    chatId: string,
    dnsNames: string[],
    validityYears: number,
    productNameId: string
  ): Observable<CheckoutSessionResponse> {
    const headers = this.getAuthHeaders();
    return this.http.post<CheckoutSessionResponse>(
      `${this.apiUrl}/stripe/initiate-payment`,
      {
        chatId,
        dnsNames,
        validityYears,
        productNameId,
      },
      { headers }
    );
  }

  // makePayment(chatId: string): Observable<CheckoutSessionResponse> {
  //   const headers = this.getAuthHeaders();
  //   return this.http.post<CheckoutSessionResponse>(
  //     `${this.apiUrl}/stripe/initiate-payment`,
  //     { chatId },
  //     { headers }
  //   );
  // }
  private apiUrl = environment.BACKEND_URL;
  constructor(private http: HttpClient, private authService: AuthService) { }

  private getAuthHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    return new HttpHeaders().set('authorization', `Bearer ${token}`);
  }

  public createSSLCheckoutSession(): Promise<any> {
    return this.http
      .get<{ clientSecret: string }>(
        `${this.apiUrl}/stripe/create-ssl-checkout`,
        {}
      )
      .toPromise();
  }

  getAllSubscriptions(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(`${this.apiUrl}/subscriptions`, { headers });
  }

  createCheckoutSession(priceId: any, returnUrl: string | null): Observable<CheckoutSessionResponse> {
    const headers = this.getAuthHeaders();
    return this.http.post<CheckoutSessionResponse>(
      `${this.apiUrl}/stripe`,
      { priceId, returnUrl },
      { headers }
    );
  }

  createCustomerPortalSession(
    email: string,
    type: string,
    price_id: string,
  ): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(
      `${this.apiUrl}/stripe/customer-portal`,
      { email, type, price_id },
      { headers }
    );
  }

  updatePlan(
    subscriptionPlanId: string
  ): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post<any>(
      `${this.apiUrl}/stripe/update-subscription`,
      { subscriptionPlanId },
      { headers }
    );
  }

  confirmSubscription(userId: string, sessionId: string): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(
      `${this.apiUrl}/stripe/confirm-subscription`,
      { userId, sessionId },
      { headers }
    );
  }

  getUserSubscription(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(`${this.apiUrl}/user/active-subscription`, {
      headers,
    });
  }

  cancelSubscription(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(`${this.apiUrl}/stripe/cancel-subscription`, {
      headers,
    });
  }

  checkTrialEligibility(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(`${this.apiUrl}/user/check-trial-eligibility`, {
      headers,
    });
  }
}